export default {
	birthNumber: 'Rodné číslo',
	birthDate: 'Datum narození',
	firstName: 'Jméno',
	businessName: 'Název',
	zipCode: 'PSČ',
	street: 'Ulice',
	streetNo: 'Číslo popisné/orientační',
	surname: 'Příjmení',
	businessIn: 'IČO',
	municipality: 'Obec',
	surnameNameBirthDate: 'Příjmení + Jméno + Datum narození',
	surnameNameMunicipality: 'Příjmení + Jméno + Obec',
	surnameNameStreet: 'Příjmení + Jméno + Ulice',
	surnameNameZipCode: 'Příjmení + Jméno + PSČ',
	businessNameBirthDate: 'Název + Datum narození',
	businessNameMunicipality: 'Název + Obec',
	businessNameStreet: 'Název + Ulice',
	businessNameZipCode: 'Název + PSČ',
};
